export const HoursConst = [
  { value: "12", label: "12" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10" },
  { value: "11", label: "11" }
];

export const MinsConst = [
  { value: "00", label: "00" },
  { value: "15", label: "15" },
  { value: "20", label: "20" },
  { value: "25", label: "25" },
  { value: "30", label: "30" },
  { value: "35", label: "35" },
  { value: "40", label: "40" },
  { value: "45", label: "45" },
  { value: "50", label: "50" },
  { value: "55", label: "55" }
];

export const StampsConst = [
  { value: "AM", label: "AM" },
  { value: "PM", label: "PM" }
];

export const onlyNumber = event => {
  const keycode = event.which;
  if (keycode === 13) {
  } else if (
    !(
      event.shiftKey === false &&
      (keycode === 8 ||
        keycode === 46 ||
        keycode === 37 ||
        keycode === 39 ||
        (keycode >= 48 && keycode <= 57))
    )
  )
    event.preventDefault();
};
export const STATE_PRO =  ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Dist. Columbia', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming', 'Alberta', 'British Columbia', 'Labrador', 'Manitoba', 'New Brunswick', 'Newfoundland', 'Nova Scotia', 'Nunavut', 'North West Terr', 'Ontario', 'Prince Edward Is', 'Quebec', 'Saskatchewen', 'Yukon']

export const FILM_TYPE = {
  1: "Premiere",
  2: "Second Screening",
  3: "Award winner",
};

export const ADVERTISEMENT_TYPE = {
  ORDER_CONFIRMATION: "order_confirmation",
  SCHEDULE_ADS: "schedule_ads"
};

export const AD_NAVIGATION_TYPE = {
  EXTERNAL_URL: "external_url",
  APP_PAGE: "app_page"
};

export const AD_NAVIGATION_TYPE_KEY = {
  EXTERNAL_URL: "externalURL",
  APP_PAGE_NAVIGATION: "appPageNavigation"
};

export const ADMIN_ROLE = [
  { value: "sio", label: "Industry" },
  { value: "press", label: "Press" },
  { value: "sundanceGuest", label: "Sundance Guest" },
  { value: "general", label: "General" },
];

export const USER_ROLE = [
  { value: "sioUser", label: "Industry" },
  { value: "pressUser", label: "Press" },
  { value: "circleGuestUser", label: "Sundance Guest" },
  { value: "generalUser", label: "General" },
  { value: "pafUser", label: "PAF USer" },
];

export const WAITLIST_STATUS = {
  RESERVED: "Reserved",
  ADMITTED: "Admitted",
  SCANNED: "Scanned",
  DELETED: "Deleted"
}
export const WAITLIST_THRESHOLD = {
  FULL_PCT: 99,    // occupancy % at which waitlist transitions to "full"
  REOPEN_PCT: 97,  // occupancy % at which waitlist transitions back from "full"
};
export const SHORT_FILM_AVAILIBILITY = [
  {value:false, label:'Available Online'},
  {value:true, label:'Unavailable Online'}
]

export const PAGE_TAKEOVER_DISPLAY_PAGE_OPTIONS = [
  { value: '/', label: 'Home' },
  { value: '/program/categories', label: 'Categories' },
  { value: '/program/films/', label: 'Films' },
  { value: '/program/schedule/', label: 'Schedule' },
  { value: '/program/partner-events/', label: 'Partner Events' },
  { value: '/program/beyond-films/', label: 'Beyond Films' },
  { value: '/tickets/in-person', label: 'Tickets In-person' },
  { value: '/tickets/online', label: 'Tickets online' },
  { value: '/venues/', label: 'Venues' },
  { value: '/how-to-fest/at-a-glance', label: 'How To Fest' },
  { value: '/highlights/', label: 'Highlights' },
  { value: 'other', label: 'Other' },
];

export const PAGE_TAKEOVER_PAGE_LABEL_MAP = {};
PAGE_TAKEOVER_DISPLAY_PAGE_OPTIONS.forEach(opt => { PAGE_TAKEOVER_PAGE_LABEL_MAP[opt.value] = opt.label; });

export const PAGE_TAKEOVER_CONDITION_TYPES = [
  { key: 'PAGE_LOADED', _id: 'pageLoaded', name: 'Page Loaded' },
  { key: 'COMPONENT_CLICKED', _id: 'componentClicked', name: 'Component Clicked' },
  { key: 'EVENT_FIRED', _id: 'eventFired', name: 'Event Fired' },
];

// Derived lookup — auto-updates when PAGE_TAKEOVER_CONDITION_TYPES entries change
// Usage: PT_CONDITION_TYPE.PAGE_LOADED === 'pageLoaded'
export const PT_CONDITION_TYPE = PAGE_TAKEOVER_CONDITION_TYPES.reduce((map, c) => {
  map[c.key] = c._id;
  return map;
}, {});
export const ADMIN_CMA_IDS = {
  // Top-level tabs
  CONFIGURATION: 1,
  COMMUNITY_HUB: 2,
  FPG: 3,
  TICKETING: 4,
  FEST: 5,
  SCREENING: 6,
  PRODUCT_COUPONS: 7,
  ABOUT_SUNDANCE: 8,
  FESTIVAL_HELP: 9,
  SPONSORS: 10,
  PRIVATE_SCREENING: 11,
  LOCATION: 12,
  POSTACCEPTANCEFORM: 13,
  PAF_PAGE_OVERRIDE: 26,
  USER_ACCESS_MANAGEMENT: 14,
  ALL_USER: 16,
  MEMBERSHIP_TOOL: 17,
  PRODUCT_TOOLS: 18,
  MOBILE_PUSH_NOTIFICATION: 19,
  USER_ACTIVITIES: 20,
  WAITLIST: 21,
  /** WAITLIST (21) sub-options */
  WAITLIST_LIST: 2101,
  WAITLIST_MY_WAITLISTS: 2102,
  /** CONFIGURATION (1) sub-options */
  CONFIG_FESTIVAL_DATES: 101,
  CONFIG_FESTIVAL_WEBSITE: 102,
  CONFIG_EMAILS: 103,
  PAGE_TAKE_OVER: 104,
  CONFIG_ARCHIVES_PAGE: 105,
  /** COMMUNITY_HUB (2) sub-options */
  COMMUNITY_HUB_INTERESTS: 201,
  /** FPG (3) sub-options */
  FPG_CATALOG: 301,
  FPG_SHORTS_PROGRAM: 302,
  FPG_REFERENCE_CATEGORY: 303,
  FPG_REFERENCE_AWARD_CATEGORY: 304,
  FPG_REFERENCE_GENRE: 305,
  FPG_REFERENCE_INTEREST_TRACKS: 306,
  FPG_REFERENCE_ACCESSIBILITY: 307,
  FPG_REFERENCE_CREDIT_LABEL: 308,
  FPG_REFERENCE_DEVICES: 309,
  FPG_REFERENCE_SCREENING_TYPES: 310,
  /** PRODUCT_COUPONS (7) sub-options */
  PRODUCT: 701,
  COUPONS: 702,
  STORE_UPSELL: 703,
  MEMBERSHIP_LIST: 704,
  /** LOCATION (12) sub-options */
  LOCATION_LIST: 1201,
  LOCATION_LANDING_PAGE: 1202,
  LOCATION_REF_VENUE_TYPE: 1203,
  LOCATION_REF_ACCESSIBILITY: 1204,
  LOCATION_REF_AMENITIES: 1205,
  ACCESS_CONTROLLED_PAGES: 25,
};

export const DISCOUNT_USER_GROUP_OPTIONS = [
  { value: 'sio', label: 'Industry' },
  { value: 'press', label: 'Press' },
  { value: 'circleGuest', label: 'Sundance Guest' },
];

export const DISCOUNT_USER_GROUP_LABELS = {
  sio: 'Industry',
  press: 'Press',
  circleGuest: 'Sundance Guest',
};

export const PAF_TYPES = {
  DOCUMENTARY_SHORTS:   'Documentary Shorts',
  DOCUMENTARY_FEATURES: 'Documentary Features',
  INDIE_SERIES:         'Episodic/Special Events',
  NEW_FRONTIER:         'New Frontier',
  NARRATIVE_SHORTS:     'Narrative Shorts',
  NARRATIVE_FEATURES:   'Narrative Features',
};

export const isNewFrontierCategory = (categoryId, ...categoryArrays) => {
    if (!categoryId) return false;
    const allCategories = categoryArrays.flat().filter(Boolean);
    const categoryName = allCategories.find(_ => _._id === categoryId)?.name || '';
    const normalized = categoryName.toLowerCase().replace(/\s+/g, '');
    return normalized.includes('newfrontier');
};
